import { render, staticRenderFns } from "./informacionCitaPaciente.vue?vue&type=template&id=67c39963&scoped=true"
import script from "./informacionCitaPaciente.vue?vue&type=script&lang=js"
export * from "./informacionCitaPaciente.vue?vue&type=script&lang=js"
import style0 from "./informacionCitaPaciente.vue?vue&type=style&index=0&id=67c39963&prod&lang=css"
import style1 from "./informacionCitaPaciente.vue?vue&type=style&index=1&id=67c39963&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c39963",
  null
  
)

export default component.exports